/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { secondarySalesPersonAssignAPI } from "@tKgpco/Services/RfqQuoteSecondarySalesPersonService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = {
    SecondarySalesRep: string;
    QuoteNumber: string;
} & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters>;

export const PopulateApiParameters: HandlerType = props => {
    const { SecondarySalesRep, QuoteNumber } = props.parameter;
    props.apiParameter = {
        SecondarySalesRep, QuoteNumber
    };
};

export const SecondarySalesPerson: HandlerType = async props => {
    try {
        const apiResult = await secondarySalesPersonAssignAPI(props.apiParameter);
        if(apiResult) {
            props.parameter.onSuccess?.(apiResult);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const chain = [PopulateApiParameters, SecondarySalesPerson];

const secondarySalesPersonAssign = createHandlerChainRunner(chain, "secondarySalesPersonAssign");
export default secondarySalesPersonAssign;